import React from "react";
import { Image, List, Spacer, Text } from "../dynamic.components";
import pumps from "src/assets/images/process_control/pumps.png";
import pumps_flow_rates from "src/assets/images/process_control/pumps_table.png";
import transfer_pump from "src/assets/images/process_control/transfer_pump.png";
import feed_pump from "src/assets/images/process_control/feed_pump.png";
import permeate_pump from "src/assets/images/process_control/permeate_pump.png";
import SubHotspots from "../Sub-hotspots";

export const Pumps_1: React.FC = (): JSX.Element => (
  <>
    <Text text="Transfer pump is a peristaltic pump used for transferring, product, diafiltration buffer, maintain constant retentate volume in the recirculation bag and for air blow down recovery." />
    <Image
      images={[
        {
          src: transfer_pump,
          alt: "transfer_pump image",
          customWidth: "50%",
        },
      ]}
    />
    <Spacer x={2} />
  </>
);
export const Pumps_2: React.FC = (): JSX.Element => (
  <>
    <Text text="Feed pump/recirculation pump  – The feed pump is diaphragm type for low shear, and the single‑use pump head is integrated in the flow kit. It is used for recirculation sample during filtration process." />
    <Image
      images={[
        {
          src: feed_pump,
          alt: "feed_pump image",
          customWidth: "50%",
        },
      ]}
    />
    <Spacer x={2} />
  </>
);
export const Pumps_3: React.FC = (): JSX.Element => (
  <>
    <Text text="Permeate pump – bidirectional pump, used for controlling permeate flow and for filter flush." />
    <Image
      images={[
        {
          src: permeate_pump,
          alt: "permeate_pump image",
          customWidth: "50%",
        },
      ]}
    />
    <Spacer x={2} />
  </>
);

export const Pumps: React.FC = (): JSX.Element => {
  return (
    <>
      <div className="c-sidebar__body">
        <SubHotspots sublinkId="4-2" />
      </div>
    </>
  );
};
